import { onTargetedAdV3Dismiss } from 'mini-gdprv3-ads-opt-in/lib/utils/targetedAdUtils';

/**
 * Wait before showing the campaigns
 */
export async function waitBeforeStart(delay?: number): Promise<void> {
    if (delay) {
        await new Promise(resolve => setTimeout(resolve, delay));
    }

    await onTargetedAdV3Dismiss();
}
